module.exports = __webpack_public_path__ + "images/places/asm_73-0dd6dee828feb4c445c3082ac1df39be.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/asm_73.jpg
 ** module id = 314
 ** module chunks = 0
 **/